import classNames from "classnames";
import "./AppButton.css";

interface AppButtonProps {
  children?: React.ReactNode;
  variant?:
    | "primary"
    | "secondary"
    | "third"
    | "light"
    | "light-2"
    | "info"
    | "highlight"
    | "success"
    | "yellow"
    | "red";
  prefix?: React.ReactNode;
  suffix?: React.ReactNode;
  disabled?: boolean;
  type?: "button" | "submit" | "reset";
  ariaLabel?: string;
  onClick?: () => void;
  noHover?: boolean;
  active?: boolean;
  sm?: boolean;
  md?: boolean;
  fullWidth?: boolean;
}

export default function AppButton({
  children,
  variant,
  prefix,
  suffix,
  disabled = false,
  type = "button",
  ariaLabel,
  onClick = () => null,
  noHover = false,
  active = false,
  sm = false,
  md = false,
  fullWidth = false,
}: AppButtonProps) {
  return (
    <button
      className={classNames("app-button", {
        [`app-button--primary`]: variant === "primary",
        [`app-button--secondary`]: variant === "secondary",
        [`app-button--third`]: variant === "third",
        [`app-button--light`]: variant === "light",
        [`app-button--light-2`]: variant === "light-2",
        [`app-button--info`]: variant === "info",
        [`app-button--highlight`]: variant === "highlight",
        [`app-button--success`]: variant === "success",
        [`app-button--yellow`]: variant === "yellow",
        [`app-button--red`]: variant === "red",
        [`app-button--nohover`]: noHover,
        [`app-button--sm`]: sm,
        [`app-button--md`]: md,
        [`app-button--active`]: active,
        [`app-button--fullWidth`]: fullWidth,
        [`app-button--disabled`]: disabled,
      })}
      aria-label={ariaLabel}
      disabled={disabled}
      onClick={onClick}
      type={type}
    >
      {prefix}
      {children && <span className="app-button_body">{children}</span>}
      {suffix}
    </button>
  );
}
